// @flow

import { push } from 'connected-react-router'
import { forceHideModal } from './_modal'
import { fetchManifest } from './manifest'
import { fetchUsers } from './users'
import { clearMyQuests, fetchMyQuests } from './myquests'
import { setMyArtifactsCourseFilter } from './myartifacts'
import {
  fetchMentorNotifications,
  clearMentorDashboardHistory
} from './mentordashboard'
import { fetchUserCourses } from './usercourses'
import {
  setCourseFilter,
  setMyStudentsSelectedTab,
  setMyStudentsSort
} from './mystudents'
import { FETCH_NOTES_FAILURE } from './notebook'
import { fetchAcademicYears } from './academicyears'
import { fetchClassRooms } from './classrooms'
import { fetchClassPeriods } from './classperiods'
import type { Action } from '../types/actions/organization'
import { updateMentorStatus } from './auth'
import { getUnsavedWorkMessage, willLoseUnsavedWork } from '../utils/unsavedwork'
import { clearUnsavedWork } from './unsavedwork'

export const SET_CURRENT_ORGANIZATION = 'SET_CURRENT_ORGANIZATION'
export const START_SET_CURRENT_ORGANIZATION = 'START_SET_CURRENT_ORGANIZATION'
export const END_SET_CURRENT_ORGANIZATION = 'END_SET_CURRENT_ORGANIZATION'
export const SET_MAX_ACTIVE_QUESTS = 'SET_MAX_ACTIVE_QUESTS'

export function setCurrentOrganizationAction(orgId: number): Action {
  return {
    type: SET_CURRENT_ORGANIZATION,
    orgId: orgId
  }
}

export function startSetCurrentOrganization(): Action {
  return {
    type: START_SET_CURRENT_ORGANIZATION
  }
}

export function endSetCurrentOrganization(): Action {
  return {
    type: END_SET_CURRENT_ORGANIZATION
  }
}

export function setMaxActiveQuests(maxActiveQuests: number): Action {
  return {
    maxActiveQuests: maxActiveQuests,
    type: SET_MAX_ACTIVE_QUESTS
  }
}

export function setCurrentOrganization(
  orgId: number,
  isMentor: boolean,
  refreshData: boolean
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const unsavedWork = state.unsavedwork.items

    if (
      !willLoseUnsavedWork({ unsavedWork }) ||
      window.confirm(getUnsavedWorkMessage())
    ) {
      dispatch(clearUnsavedWork())

      state.organization.orgId = orgId

      localStorage.setItem('lastSelectedOrgId', orgId.toString())

      // refresh data happens when user manually changes organizations
      if (refreshData) {
        dispatch(startSetCurrentOrganization())
        dispatch(push('/loading'))

        const currentOrg = state.auth.user.organizations.find(function (org) {
          return org.id === orgId
        })

        await dispatch(setCurrentOrganizationAction(orgId))

        await Promise.all([
          dispatch(
            setMaxActiveQuests(currentOrg ? currentOrg.max_active_quests : 6)
          ),
          dispatch(fetchUserCourses(state.auth.user.id, false, false, isMentor)),
          dispatch(fetchUserCourses(state.auth.user.id, false, true, isMentor)), // need to fetch past courses too
          dispatch(fetchUsers()),
          dispatch({ type: FETCH_NOTES_FAILURE }), // hack, clears the notebook
          dispatch(forceHideModal()),
          dispatch(setMyArtifactsCourseFilter(-1)),
          dispatch(fetchAcademicYears()),
          dispatch(fetchClassPeriods()),
          dispatch(fetchClassRooms()),
          dispatch(updateMentorStatus(isMentor))
        ])

      if (!isMentor) {
        await dispatch(clearMyQuests())
        await dispatch(fetchMyQuests(true))
        dispatch(push(`/user/${state.auth.user.id}/dashboard`))
        dispatch(endSetCurrentOrganization())
      } else {
        localStorage.removeItem('courseId')

          await Promise.all([
            dispatch(fetchManifest()),
            dispatch(fetchMentorNotifications()),
            dispatch(clearMentorDashboardHistory()),
            dispatch(setCourseFilter(-1)),
            dispatch(setMyStudentsSelectedTab('journeyoverview')),
            dispatch(setMyStudentsSort('journeyprogress', 'asc')),
            dispatch(fetchUserCourses(state.auth.user.id, false, true, isMentor)) // need to fetch past courses too
          ])

          const newState = getState()

          dispatch(
            push(
              newState.auth.userHasCurrentCourses
                ? '/mystudents/journeyoverview'
                : newState.auth.userHasPastCourses
                ? '/mentordashboard'
                : '/mycommunity'
            )
          )

          dispatch(endSetCurrentOrganization())
        }
      } else {
        // this happens on login
        dispatch(setCurrentOrganizationAction(orgId))
      }
    }
  }
}
